import { render } from "./Move1BlockComponent.vue?vue&type=template&id=374a9cb0&scoped=true"
import script from "./Move1BlockComponent.vue?vue&type=script&lang=js"
export * from "./Move1BlockComponent.vue?vue&type=script&lang=js"

import "./Move1BlockComponent.vue?vue&type=style&index=0&id=374a9cb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-374a9cb0"

export default script